<script setup>
import { ref } from "vue";
import Menu from "@/components/base/Menu.vue";

const isOpen = ref(false);

const handleClick = () => {
  isOpen.value = !isOpen.value;
  document.body.style.overflow = isOpen.value ? "hidden" : "";
}
</script>

<template>
  <div class="burger relative" :class="{ open: isOpen }" @click="handleClick">
    <span class="line"></span>
    <span class="line"></span>
    <span class="line"></span>
  </div>
  <Menu :open="isOpen" @close="isOpen = false" />
</template>

<style scoped lang="scss">
.burger {
  width: clamp(26px, 1.806vw, 130px);
  height: clamp(21px, 1.458vw, 105px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  z-index: 10;
  &:hover .line {
    background: #16ADFC;
  }
}

.line {
  display: block;
  height: clamp(4px, 0.278vw, 20px);
  width: 100%;
  background: #FFFFFF;
  transition: all 0.3s ease;
}

.burger.open .line:nth-child(1) {
  transform: translateY(clamp(8px, 0.556vw, 40px)) rotate(45deg);
}

.burger.open .line:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.burger.open .line:nth-child(3) {
  transform: translateY(calc((-1) * clamp(9px, 0.625vw, 45px))) rotate(-45deg);
}
</style>